const at = (m, d) => new Date(2027, m, d, 10, 30).getTime();
const users = (dom, names) => names.map((n, i) => ({
  name: n,
  email: `${n.split(" ")[0].toLowerCase()}@${dom}`,
  role: i === 0 ? "admin" : "recruiter",
}));

export const STATUSES = {
  pending_payment: { label: "Pendiente de pago", cls: "bg-amber-100 text-amber-800" },
  payment_review: { label: "Pago en verificación", cls: "bg-sky-100 text-sky-800" },
  paid: { label: "Pago confirmado", cls: "bg-indigo-100 text-indigo-800" },
  approved: { label: "Aprobada", cls: "bg-emerald-100 text-emerald-800" },
  rejected: { label: "Rechazada", cls: "bg-rose-100 text-rose-800" },
};

export const BANK = {
  beneficiary: "Universitat Politècnica de València",
  iban: "[IBAN de la UPV]",
  amount: "[Importe a definir por la UPV]",
};

export const SEED_APPLICATIONS = [
  {
    id: "app-1", ref: "FE27-101", status: "approved", stand: "D-01", createdAt: at(2, 3),
    name: "Nexora Robotics S.L.", cif: "B11111111", sector: "Tecnología e ingeniería", web: "nexora.example", address: "Calle Ejemplo 1, València",
    contactName: "Pau Martí", contactEmail: "pau@nexora.example", contactPhone: "+34 600 000 001",
    description: "Empresa de demostración especializada en robótica colaborativa. Buscamos talento en software e ingeniería industrial.",
    titulaciones: ["Ingeniería Informática", "Ingeniería Industrial"],
    offers: [{ title: "Ingeniero/a de Automatización", type: "Prácticas" }, { title: "Ingeniero/a de Software", type: "Empleo" }],
    users: users("nexora.example", ["Pau Martí", "Clara Vidal", "Joan Ferrer"]), receipt: "justificante_nexora.pdf",
  },
  {
    id: "app-2", ref: "FE27-102", status: "payment_review", createdAt: at(2, 18),
    name: "Valtic Energía S.A.", cif: "A22222222", sector: "Energía", web: "valtic.example", address: "Avenida Ejemplo 2, València",
    contactName: "Rosa Llop", contactEmail: "rosa@valtic.example", contactPhone: "+34 600 000 002",
    description: "Empresa de demostración del sector energético. Buscamos perfiles de ingeniería eléctrica y de datos.",
    titulaciones: ["Ingeniería Eléctrica", "Ciencia de Datos"],
    offers: [{ title: "Ingeniero/a de Proyectos Energéticos", type: "Programa graduados" }],
    users: users("valtic.example", ["Rosa Llop", "Iker Sanz", "Mar Gil"]), receipt: "justificante_valtic.pdf",
  },
  {
    id: "app-3", ref: "FE27-103", status: "pending_payment", createdAt: at(3, 2),
    name: "Lumen Data Lab S.L.", cif: "B33333333", sector: "Consultoría tecnológica", web: "lumen.example", address: "Plaza Ejemplo 3, València",
    contactName: "Toni Roca", contactEmail: "toni@lumen.example", contactPhone: "+34 600 000 003",
    description: "Empresa de demostración de analítica de datos. Buscamos perfiles de ciencia de datos y consultoría.",
    titulaciones: ["Ciencia de Datos", "Administración y Dirección de Empresas"],
    offers: [{ title: "Ingeniero/a de Datos", type: "Prácticas" }],
    users: users("lumen.example", ["Toni Roca", "Alba Mas", ""]), receipt: null,
  },
];
